<template lang="pug">
  b-card.mb-0.h-100.bg-shapes(no-body)
    b-card-body(style="z-index:1")
      //h5.mb-3 Vista previa
      .bg-white.p-2.rounded.mb-2
        h6.text-bold.mb-1(v-if="header.format === 'TEXT'") {{parse_header}}
        .text-center.text-white.bg-soft-cool.mb-1(v-else-if="header.format")
          div(v-if="header.format === 'IMAGE'")
            b-img.img-fluid(v-if="image_preview", :src="image_preview", style="object-fit: contain;")
            v-icon.my-2(v-else, name="image", scale="4")
          div(v-if="header.format === 'DOCUMENT'")
            iframe.img-fluid(v-if="image_preview", :src="image_preview", width="auto", height="200", frameborder="0")
            v-icon.my-2(v-else, name="file", scale="4")
          div(v-if="header.format === 'VIDEO'")
            video.img-fluid(v-if="image_preview", :src="image_preview", controls)
            v-icon.my-2(v-else, name="video", scale="4")
        .break-space(v-html="format_message")
        .text-sm.text-help {{footer}}
        .text-right.text-sm.text-secondary(style="font-size: 10px;") {{current_time}}
      .text-info.bg-white.btn.text-break.mb-2.btn-block.text-sm(v-for="(btn, index) in buttons", :key="index", v-if="btn.text")
        external-link-icon.icon-sm.mr-2(v-if="btn.type === 'URL'")
        phone-icon.icon-sm.mr-2(v-else-if="btn.type === 'PHONE_NUMBER'")
        span {{btn.text}}
</template>

<script>
import {mapActions} from 'vuex'

export default {
  data () {
    return {

    }
  },
  props: {
    header: {
      type: Object,
      default: () => {
        return {
          format: null,
          text: ""
        }
      }
    },
    header_example_text: {
      type: String,
      default: ""
    },
    header_example_file: {
      type: File,
      default: null
    },
    body_message: {
      type: String,
      default: ""
    },
    body_example: {
      type: Array,
      default: () => {
        return []
      }
    },
    footer: {
      type: String,
      default: ""
    },
    buttons: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultUrl:{
      type: String,
      default: ""
    }
  },
  computed: {
    image_preview () {
      const {defaultUrl,header_example_file} = this
      if(defaultUrl)return defaultUrl
      if(header_example_file) return URL.createObjectURL(header_example_file)
      return false
    },
    parse_header () {
      if(this.header_example_text) return this.header.text.replace(/\{\{\d+\}\}/g, this.header_example_text)
      return this.header.text
    },
    format_message () {
      let message = this.body_message
      if(this.body_example.length) {
        message = message.replace(/\{\{\d+\}\}/g, match => {
          let index = this.body_vars.indexOf(match)
          if(index >= 0) return this.body_example[index] || match
          return match
        })
      }
      return message.replace(/\*([^*]*)\*/g, "<strong>$1</strong>")
                    .replace(/_([^_]*)_/g, "<em>$1</em>")
                    .replace(/~([^~]*)~/g, "<del>$1</del>")
                    .replace(/```([^`]*)```/g, "<code>$1</code>")
    },
    body_vars () {
      let match = this.body_message.match(/\{\{\d+\}\}/g)
      return match ? match.filter((value, index, self) => self.indexOf(value) === index) : []
    },
    current_time (){
      let dateWithoutSecond = new Date();
      return dateWithoutSecond.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
    },
  },
  methods: {
    ...mapActions([]),
  },
}
</script>

<style lang="scss">

.bg-shapes{
  background-color: #e5ddd5 !important;
}

.bg-shapes::before {
  content: "";
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  background: url("../assets/ilustrations/whats_bg.png") repeat;
}

</style>
